export * from './CurrentWordDisplay';
export { default } from './CurrentWordDisplay';
